import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_04bafee8 from 'nuxt_plugin_plugin_04bafee8' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_01590b11 from 'nuxt_plugin_recaptcha_01590b11' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_gtm_79c7e4f8 from 'nuxt_plugin_gtm_79c7e4f8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_ef0fc4bc from 'nuxt_plugin_axios_ef0fc4bc' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5716394a from 'nuxt_plugin_cookieuniversalnuxt_5716394a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginserver_4c6c19ba from 'nuxt_plugin_pluginserver_4c6c19ba' // Source: ./plugin.server.js (mode: 'server')
import nuxt_plugin_deviceplugin_38f0f32d from 'nuxt_plugin_deviceplugin_38f0f32d' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_i18n_66ff12a5 from 'nuxt_plugin_i18n_66ff12a5' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_axios_397e53b5 from 'nuxt_plugin_axios_397e53b5' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_vueyoutube_7e6334e2 from 'nuxt_plugin_vueyoutube_7e6334e2' // Source: ../plugins/vue-youtube.js (mode: 'all')
import nuxt_plugin_vuedompurifyhtml_15868735 from 'nuxt_plugin_vuedompurifyhtml_15868735' // Source: ../plugins/vue-dompurify-html.js (mode: 'all')
import nuxt_plugin_vuekinesis_10ed8d2c from 'nuxt_plugin_vuekinesis_10ed8d2c' // Source: ../plugins/vue-kinesis.js (mode: 'client')
import nuxt_plugin_vueswiper_3cd508da from 'nuxt_plugin_vueswiper_3cd508da' // Source: ../plugins/vue-swiper (mode: 'client')
import nuxt_plugin_toast_05aea064 from 'nuxt_plugin_toast_05aea064' // Source: ../plugins/toast.js (mode: 'all')
import nuxt_plugin_antui_860997ee from 'nuxt_plugin_antui_860997ee' // Source: ../plugins/ant-ui.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Super Sus","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, minimal-ui"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"alternate","hreflang":"en","href":"https:\u002F\u002Fwww.supersus.io\u002Fen\u002F"},{"rel":"alternate","hreflang":"th","href":"https:\u002F\u002Fwww.supersus.io\u002Fth\u002F"},{"rel":"alternate","hreflang":"id","href":"https:\u002F\u002Fwww.supersus.io\u002Fid\u002F"},{"rel":"alternate","hreflang":"hi","href":"https:\u002F\u002Fwww.supersus.io\u002Fhi\u002F"},{"rel":"alternate","hreflang":"x-default","href":"https:\u002F\u002Fwww.supersus.io\u002Fen\u002F"}],"script":[{"src":"\u002Fscript\u002Fredirect.js","type":"text\u002Fjavascript","charset":"utf-8","body":false},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-PJTHN2V')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-PJTHN2V&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_04bafee8 === 'function') {
    await nuxt_plugin_plugin_04bafee8(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_01590b11 === 'function') {
    await nuxt_plugin_recaptcha_01590b11(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_79c7e4f8 === 'function') {
    await nuxt_plugin_gtm_79c7e4f8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ef0fc4bc === 'function') {
    await nuxt_plugin_axios_ef0fc4bc(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5716394a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5716394a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_4c6c19ba === 'function') {
    await nuxt_plugin_pluginserver_4c6c19ba(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_38f0f32d === 'function') {
    await nuxt_plugin_deviceplugin_38f0f32d(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_66ff12a5 === 'function') {
    await nuxt_plugin_i18n_66ff12a5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e53b5 === 'function') {
    await nuxt_plugin_axios_397e53b5(app.context, inject)
  }

  if (typeof nuxt_plugin_vueyoutube_7e6334e2 === 'function') {
    await nuxt_plugin_vueyoutube_7e6334e2(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedompurifyhtml_15868735 === 'function') {
    await nuxt_plugin_vuedompurifyhtml_15868735(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuekinesis_10ed8d2c === 'function') {
    await nuxt_plugin_vuekinesis_10ed8d2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueswiper_3cd508da === 'function') {
    await nuxt_plugin_vueswiper_3cd508da(app.context, inject)
  }

  if (typeof nuxt_plugin_toast_05aea064 === 'function') {
    await nuxt_plugin_toast_05aea064(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_antui_860997ee === 'function') {
    await nuxt_plugin_antui_860997ee(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
